<template>
  <div v-if="is_load" class="main_page_content">
    <nav   aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Главная</a></li>
        <li class="breadcrumb-item"><a href="/shop">На продажу</a></li>
        <li class="breadcrumb-item active" aria-current="page">{{ item.title}}</li>
      </ol>
    </nav>
    <section class="section section section-shaped my-0 overflow-hidden content_background_color_blue2">
      <div class="shape shape-style-1 bg-gradient-warning ">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>

      </div>

      <div class="container py-0 ">
        <div class="row row-grid mb-5 align-items-center">
          <div class="d-flex px-3">
            <div>
              <div class="col-12 col-md-6 col-lg-6">
                <img class="img img-thumbnail" :src="item.photos[0]">
              </div>
            </div>

            <div class="mt-4">




            </div>
          </div>

          <card class="col-12">
            <h2>  {{ item.title}}</h2>
            <p><b>Категория</b>:{{ category.title}}</p>
            <p><b>Цена</b>: {{item.price}} {{ item.currency}}</p>
            <div class="row alert alert-success" v-for="(option,option_key) in item.options" :key="option_key"
                 v-if="item.options.length>0">
              <p><input type="checkbox" :value="true" @change="changeOptions(option_key)" v-model="custom_options[option_key]">{{ option.title}} <b>+{{ option.price }} {{ item.currency}}</b></p>

            </div>
            <div class="row alert alert-success">
              <p><button type="button" @click="addToCart()" class="btn btn-default">Добавить в корзину {{custom_price}} {{ item.currency}}</button></p>
            </div>


            <editorjsrender class="ml-3" v-if="is_load " :blocks_json="item.content_json.blocks"></editorjsrender>
          </card>



        </div>
      </div>
    </section>
  </div>
</template>

<script>

import Api from "../../models/Api";
import Vue from "vue";
import Editorjsrender from "@/models/Editorjsrender";




var Avatar = require('vue-avatar');


export default {
  name: 'Item',

  components: {
    'editorjsrender': Editorjsrender,
  },
  data() {
    return {
      "category":null,
      "item":[],
      "custom_options":[],
      "custom_price":0,
      "is_load":false,
    }
  },
  mounted() {
    var last_id=this.$route.params.id;

    var app=this;
    Api.loadItem_by_last_id(last_id,function(data){


      app.category=data.item.category;
      app.item=data.item;
      app.custom_price=data.item.price;
      app.is_load=true;
    })
  },
  methods: {
    changeOptions(key){
      var app=this;
      var custom_price=parseInt(app.item.price);
      if(app.item.options.length>0){
        app.item.options.forEach(function(item, i, arr) {
          console.log(app.custom_options[i]);
           if(app.custom_options[i]){
             custom_price+=parseInt(item.price);
             app.custom_price=custom_price;
           }
        });

      }
    },
    addToCart(){
      var app=this;

      var item={};
      item.last_id=app.item.last_id;
      item.title=app.item.title;
      item.photos=app.item.photos;
      item.price=app.item.price;
      item.custom_price=app.custom_price;
      item.currency=app.item.currency;
      item.options=app.item.options;
      item.custom_options=app.custom_options;
      item.count=1;
      item.total_price=parseInt(item.custom_price)*item.count;

      var query_obj={};
      if(localStorage.getItem('api_token')){
        query_obj.rand_code=localStorage.getItem('api_token');
      }

      Api.addToCart(item);
      app.$router.push({path: "/cart",query:query_obj});

      app.custom_options=[];

      app.custom_price=parseInt(app.item.price);

    }




  }
};
</script>
